import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Redux
import { Provider } from 'react-redux';
import store from "./app/store";

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css';

// MUI Theme global con la tipografía de marca
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Importar el archivo CSS global
import './index.css';

const brandTheme = createTheme({
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={brandTheme}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
